module.exports = __webpack_public_path__ + "img/adv_search_spells.7ae46154.svg";